import AppContext from "PFApp/app_context";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";

import CVUploadStep from "./steps/cv_upload_step";
import DetailsStep from "./steps/details_step";
import ReviewStep from "./steps/review_step";
import SkillsStep from "./steps/skills_step";
import SuccessStep from "./steps/success_step";
import TermsAndConditionsStep from "./steps/terms_and_conditions_step";
import TopSkillsStep from "./steps/top_skills_step";

const OnboardingPage = () => {
  const { step } = useParams();
  const history = useHistory();
  const {
    store: { currentProfile, currentAccount }
  } = useContext(AppContext);

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    // todo: how to achieve that with hooks? (wrapper component?)
    if (currentProfile.registration_status) {
      // registration_status is undefined when the currentProfile is yet to be loaded
      if (currentProfile.registration_status !== "active") {
        storage.setItem("OnboardingInitiated", true, { expiresIn: 60 * 60 * 2 });
      } else if (!storage.getItem("OnboardingInitiated")) {
        setDisabled(true); // to avoid split second render of onboarding before navigation happens
        history.push("/", { trigger: true, reload: true });
      }
    }
  }, [currentProfile.registration_status]);

  if (!currentProfile.id || disabled) {
    return null;
  }

  if (step === "tos" && !currentAccount.customization.show_terms_and_conditions) {
    return <Redirect to="/onboarding/cv" />;
  }

  if (step === "cv" && !currentAccount.cv_parser_config.enabled) {
    return <Redirect to="/onboarding/details" />;
  }

  const isTosShown = currentAccount.show_terms_and_conditions;
  const isTosAccepted = currentProfile.agree_to_terms_and_conditions === true;
  if (step === "tos" || (isTosShown && !isTosAccepted)) {
    return <TermsAndConditionsStep />;
  } else if (step === "cv") {
    return <CVUploadStep />;
  } else if (step === "details") {
    return <DetailsStep />;
  } else if (step === "skills") {
    return <SkillsStep />;
  } else if (step === "top_skills") {
    return <TopSkillsStep />;
  } else if (step === "review") {
    return <ReviewStep />;
  } else if (step === "success") {
    return <SuccessStep />;
  }

  return <Redirect to="/onboarding/tos" />;
};

export default OnboardingPage;
